<template>
  <div class="common-table">
    <el-table
      v-loading="config.loading"
      :data="tableData"
      height="90%"
      highlight-current-row
      border
      stripe
      :header-row-style="TableHeaderRowStyle"
      :header-cell-style="TableHeaderCellStyle"
      :row-style="TableRowStyle"
      :cell-style="TableCellStyle"
    >
      <el-table-column label="序号" prop="id" width="80"></el-table-column>
      <el-table-column label="项目或工地" prop="xiangmuorgongdi" width="160"></el-table-column>
      <el-table-column label="所属库房" prop="cangku_name" width="100"></el-table-column>
      <el-table-column label="材料名称" prop="cailiao_cailiaoguige" width="140"></el-table-column>
      <el-table-column label="损耗数量" prop="sunhaoshu" width="80"></el-table-column>
      <el-table-column label="报损时间" prop="date" width="100" sortable></el-table-column>
      <el-table-column label="损耗说明" prop="remark" min-width="150"></el-table-column>
      <el-table-column align="center" label="损耗单据" width="120">
        <template slot-scope="scope">
          <el-button type="success" size="mini" @click="handlePhotos(scope.row)">损耗单据</el-button>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="90">
        <template slot-scope="scope">
          <el-tag :type="scope.row.caiwu_shenhe ? 'success' : 'warning'">{{ scope.row.caiwu_shenhe ? '已审核' : '未审核' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="添加" prop="added" width="150"></el-table-column>
      <el-table-column label="管理" width="200">
        <template slot-scope="scope">
          <el-button type="warning" icon="el-icon-delete" size="mini" @click="deleteTableRow(scope.$index, scope.row)" v-if="canDelete(scope.row)"></el-button>
          <el-button type="warning" size="mini" @click="handleWuzi_shenhe(scope.row)" v-if="!scope.row.wuzi_shenhe && userType.code === '4'"
            >物资审核</el-button
          >
          <el-button
            type="danger"
            size="mini"
            @click="handleCaiwu_shenhe(scope.row)"
            v-if="scope.row.wuzi_shenhe && !scope.row.caiwu_shenhe && userType.code === '7'"
            >财务审核</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-size="pagesize"
      layout="prev, pager, next"
      :total="config.total"
      :current-page.sync="config.page"
      @current-change="changePage"
    ></el-pagination>
  </div>
</template>

<script>
import utils from '@/assets/js/utils'
export default {
  props: {
    tableData: Array,
    config: Object,
    userType: Object
  },
  data() {
    return {
      pagesize: 20,
      TableHeaderRowStyle() {
        return 'height:35px'
      },
      TableHeaderCellStyle() {
        return 'padding-bottom:4px;padding-top:4px;font-size:12px;font-weight:700;color:#000;'
      },
      TableRowStyle() {
        return 'height:35px'
      },
      TableCellStyle() {
        return 'padding-bottom:4px;padding-top:4px;font-size:12px;color:#000;'
      }
    }
  },
  computed: {
    canDelete() {
      return function(row) {
        if (this.userType.kufanghuiku_del) {
          if (this.userType.code === '1') return true
          else {
            let added_person_time = utils.stringToDate(row.added.split('\n')[1])
            let now = new Date()
            let interval = now.getTime() - added_person_time.getTime()
            interval = interval / 1000 / 60 / 60
            console.log('addedtime:', added_person_time)
            console.log('now:', now)
            console.log('del..........', interval)
            if (interval > 2) return false
            else return true
          }
        } else return false
      }
    }
  },
  methods: {
    //换页
    changePage(page) {
      this.$emit('changePage', page)
    },
    handleCaiwu_shenhe(row) {
      this.$emit('Caiwu_shenhe', row)
    },
    handleWuzi_shenhe(row) {
      this.$emit('Wuzi_shenhe', row)
    },
    deleteTableRow(index, row) {
      this.$confirm('此操作将删除该损耗信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.get('/deleteSunhaoxinxi/?id=' + row.id).then(res => {
          if (res.data.code === '1000') {
            this.$message({
              type: 'success',
              message: '删除成功！'
            })
            this.tableData.splice(index, 1)
          } else {
            this.$message({
              message: '删除失败，此信息不存在或已被删除'
            })
          }
        })
      })
    },
    //显示图片
    handlePhotos(row) {
      this.$emit('showPhotos', row)
    }
  }
}
</script>

<style scoped></style>

<style>
.el-table .cell {
  white-space: pre-line;
  text-align: center;
}
</style>
